import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { PropertyFeatureService } from '../property-feature.service';
import { PropertyFeature } from '../property-feature';
import { FeatureService } from '@app/_components/property/feature/feature.service';
import { PropertyService } from '@app/_components/property/property.service';
import { FeaturesService } from '@app/_components/feature/features.service';
import { FeatureAdminContainerComponent } from '../../feature/feature-admin-container/feature-admin-container.component';
import { PropertyFeatureTemplateService } from '../../property-feature-template/property-feature-template.service';
import { PropertyFeatureTemplateComponent } from '../../property-feature-template/property-feature-template/property-feature-template.component';

@Component({
    selector: 'app-property-feature',
    templateUrl: './property-feature.component.html',
    styleUrls: ['./property-feature.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class PropertyFeatureComponent implements OnInit {
    properties: any;
    features: any;
	showPropertyFeatureTemplate = false;
    propertyFeatureTempletes: any;
    propertyFeatures: any;

	constructor(
		private propertyFeatureTemplateService: PropertyFeatureTemplateService,
		private featureService: FeatureService,
		private featuresService: FeaturesService,
		private propertyService: PropertyService,
		private primengConfig: PrimeNGConfig,
		private propertyFeatureService: PropertyFeatureService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.propertyFeature = data.propertyFeature? data.propertyFeature : null,
			this.propertyFeatures = data.propertyFeatures? data.propertyFeatures : null,
			this.showPropertyFeatureTemplate = data.showPropertyFeatureTemplate;
			this.statuses = propertyFeatureService.statuses;
	}

	@Input() propertyFeature: PropertyFeature;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	propertyFeatureId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'propertyFeatureId': [],
		'featureId': [],
		'featureName': [],
		'shortTermRentalId': [],
		'propertyCode': [],
		'developmentId': [],
		'activityId': [],
		'guestBookId': [],
		'title': [],
		'name': [],
		'highlight': [],
		'featureType': [],
		'featureDesc': [],
		'defaultFeature': [],
		'featureLabel': [],
		'quantity': [],
		'distance': [],
		'distanceUnit': [],
		'describesType': [],
		'kbmMap': [],
		'vrboMap': [],
		'rentalsUnitedMap': [],
		'privateNotes': [],
		'status': [],
		'propertyFeatureTemplateId': [],
	};

	highlights = [
		{ name: 'None', value: '' },
		{ name: 'Details', value: 1 },
		{ name: 'Details+Summary', value: 2 },
		{ name: 'Details+Summary+Results', value: 3 },
	];

	ngOnInit() {
		this.fetchPropertyFeatureTemplate();
		this.fetchFeature();
		this.fetchProperties();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole propertyFeature object
		if (this.propertyFeature) {
			this.propertyFeatureId = this.propertyFeature.propertyFeatureId;
			this.fixDates();
			this.form1.patchValue(this.propertyFeature);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.propertyFeatureId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.propertyFeatureService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.propertyFeature = res.data.propertyFeature;
						this.doAdd.emit(this.propertyFeature);
					},
					(err: any) => {
						console.log('propertyFeature-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('propertyFeature: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.propertyFeatureService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.propertyFeature = res.data.propertyFeature;
						this.doUpdate.emit(this.propertyFeature);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.propertyFeatureService.delete(this.propertyFeature.propertyFeatureId)
				.subscribe(
					(res: any) => {
						console.log('propertyFeature-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.propertyFeature);
					},
					(err: any) => {
						console.log('propertyFeature-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			propertyFeatureId: [this.propertyFeatureId],
			featureId: [],
			featureName: [],
			shortTermRentalId: [],
			propertyCode: [],
			developmentId: [],
			activityId: [],
			title: [],
			guestBookId: [],
			name: [],
			highlight: [],
			featureType: [],
			defaultFeature: [],
			featureDesc: [],
			featureLabel: [],
			quantity: [],
			distance: [],
			distanceUnit: [],
			describesType: [],
			kbmMap: [],
			vrboMap: [],
			rentalsUnitedMap: [],
			privateNotes: [],
			status: [],
			propertyFeatureTemplateId: []
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.propertyFeature.propertyFeatureDate = moment(this.propertyFeature.propertyFeatureDate).toDate();
	}
	
	fetchProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			try {
				this.propertyService.propertySummaryForShortData()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.properties = res.data.properties;
							return this.properties;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.properties);
		}
	}
	
	fetchFeature() {
		if (!this.features || this.features === undefined || this.features.length < 1) {
			try {
				this.featureService.findAll()
					.subscribe(
						res => {
							console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.features = res.data.propertyFeatures;
							return this.features;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.features);
		}
	}
	
	fetchPropertyFeatureTemplate() {
		if (!this.propertyFeatureTempletes || this.propertyFeatureTempletes === undefined || this.propertyFeatureTempletes.length < 1) {
			try {
				this.propertyFeatureTemplateService.findAll()
					.subscribe(
						res => {
							console.log('findAllpropertyFeatureTemplateSummary: ' + JSON.stringify(res));
							this.propertyFeatures = res.data.propertyFeatureTemplates;
							return this.propertyFeatures;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.propertyFeatureTempletes);
		}
	}

/*********
		* Copy To Feature
		*
		*/
	copyToFeature() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		// name comes as title, so copy the title into the name field
		this.propertyFeature.name = this.propertyFeature.title; 
		
		dialogConfig.data = {
			feature: this.propertyFeature,
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(FeatureAdminContainerComponent, dialogConfig);
	}
	
	addToTemplate() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
				for (let i = 0; i < this.propertyFeatures.length; i++) 
				{
				this.propertyFeatures[i].propertyFeatureTemplateId = this.form1.value.propertyFeatureTemplateId;
			  	console.log("propertyFeature propertyFeature : "+JSON.stringify(this.propertyFeatures[i]));
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.propertyFeatureService.addToTemplate(this.propertyFeatures)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Successfully add features', detail: res.message });
						/*this.propertyFeature = res.data.propertyFeature;*/
						this.doAdd.emit(this.propertyFeature);
					},
					(err: any) => {
						console.log('propertyFeature-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}
	
	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Property Feature Template'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertyFeatureTemplateComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				this.fetchPropertyFeatureTemplate();

				// close the dialogBox
				dialogRef.close();
			});
	}

}
